const formFieldRegexValidations = {
  urlRegexMatchUp: 'matchRegexp:^(https?:\\/\\/(?:drive\\.google\\.com\\/\\S*|docs\\.google\\.com\\/\\S*|\\S+\\.pdf))$', //for pdf url only
  numbersOnly: 'matchRegexp:^[0-9]+$',
  floatNumber: 'matchRegexp:^\\d*(\\.\\d+)?$',
};


export default formFieldRegexValidations;
